import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import CourierBaseLogo from '../../assets/svg/courier-base-logo.svg';
import { transformCardImageBasedXLargeData } from '../../utils';
import CardImageBasedXLarge from '../Cards/CardImageBased/CardImageBasedXLarge';
import HomepageHeroFeatured from './HomepageHeroFeatured';
import HomepageHeroLatest from './HomepageHeroLatest';

const HomepageHero = ({ carousel: _carousel, featuredArticles, latest }) => {
  const carousel = transformCardImageBasedXLargeData(_carousel);

  return (
    <div className="mt-6 mb-10 sm:mt-10">
      <div className="homepage-grid-container">
        <div
          className={classnames(
            'col-span-12',
            'relative',
            'lg:sticky',
            'h-[fit-content]',
            'lg:top-24',
          )}
          data-module-id="homepage_hero"
        >
          <CourierBaseLogo className="relative z-10 w-full fill-current text-liquorice" />
          <div className="transform -translate-y-2 sm:-translate-y-5">
            <CardImageBasedXLarge carousel={carousel} />
          </div>
        </div>
        <div className="col-span-12 mt-14 sm:mt-16 lg:col-span-4 lg:mt-0">
          <HomepageHeroFeatured articles={featuredArticles} />
        </div>
        {/* desktop latest */}
        <div className="hidden col-span-12 lg:block mt-14 sm:mt-16 lg:col-span-4 lg:mt-0">
          <HomepageHeroLatest content={latest} />
        </div>
      </div>
      {/* mobile side scroll */}
      <div className="lg:hidden mt-14 sm:mt-16 lg:col-span-4 lg:mt-0">
        <HomepageHeroLatest content={latest} isMobile />
      </div>
    </div>
  );
};

HomepageHero.propTypes = {
  carousel: PropTypes.array,
  featuredArticles: PropTypes.array,
  latest: PropTypes.array,
};

export default HomepageHero;
